import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api_url } from '../../constants/data';
import axios from 'axios';
function MailboxContent2({ onNext }) {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [isError, setIsError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const navigate = useNavigate();


    // Handle form inputs change
    const handleemailChange = (event) => {
        setEmail(event.target.value);
    };

    const handlePasswordChange = (event) => {
        setPassword(event.target.value);
    };


    const handleNextClick = async () => {
        // Validation check before submission
        if (!email || !password) {
            setErrorMessage('E-mail or pasword is incorrect');
            setIsError(true);
            return;
        }

        const loginData = {
            email,
            password,
        };

        axios.post(`${api_url}/login`, loginData).then(res => {
            if (res.data?.token) {
                localStorage.setItem('auth_token', res.data.token);

                navigate('/')
            } else {
                setErrorMessage('Invalid credentials')
                setIsError(true);
            }
        }).catch(err => {
            setErrorMessage(err.response.data.error)
            setIsError(true);
        })
    };


    return (
        <div className="r-content r-mailbox loginform">
            <h4 className="content-title">Log in</h4>
            <p className="content-text">
                Log in to the application with the e-mail and password you received at the end of submitting the application or question
            </p>
            <br />
            <form method="POST" className="mailbox">
                <div className="fill-opt1">
                    <p>E-mail</p>
                    <input
                        type="email"
                        value={email}
                        onChange={handleemailChange}
                    />
                </div>
                <div className="fill-opt1">
                    <p>Password</p>
                    <input
                        type="password"
                        value={password}
                        onChange={handlePasswordChange}
                    />
                </div>
            </form>
            {isError && <div className="error" style={{ color: 'red', marginTop: '10px' }}>{errorMessage}</div>}

            <div className="back-next">
                {/* <button className="Backbtn">Back</button> */}
                <button className="Nextbtn" onClick={handleNextClick}>
                    Log In
                </button>
            </div>
            <button className='Nextbtn registerbtn' onClick={() => navigate('/ReportMain')}>Register</button>
            <p className="content-text alreadyregistered">
                If you already have a completed report, you can go through authorization. Log in to the application with te e-mail and password you recieved at the end of submitting the application or question
            </p>

        </div>
    );
}

export default MailboxContent2;
